// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yC6nuIT1dO6k4l {
  grid-area: zip;
}
.YsEnwPLs5JEztf input[type='text'] {
  height: 40px;
}
`, ""]);
// Exports
export var container = `yC6nuIT1dO6k4l`;
export var input = `YsEnwPLs5JEztf`;
export default ___CSS_LOADER_EXPORT___;
